import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
function LoginForm() {
  const [form, setForm] = useState({ admin_email: "", password: "" });
  const navigate = useNavigate(); 
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/admin/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    const data = await res.json();
    if (res.ok) {
      alert("Login successful");
      localStorage.setItem("token", data.token);
       navigate("/users");
    } else {
      alert(data.message || "Login failed");
    }
  };

  return (
    <div className="container">
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={form.admin_email}
          onChange={(e) => setForm({ ...form, admin_email: e.target.value })}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          required
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default LoginForm;
